var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-contact';
                    var viewUrl = 'sprite.svg#view-icon-contact';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-contact#icon-contact';
                            viewUrl = 'sprite.svg?icon-contact#view-icon-contact';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 21.6 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };